import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { ProductInventoriesSearchParams } from "../../schemas"

import { InventoryFilterChipGroup } from "@/screens/Inventory/components"
import type { Option } from "@/types/form-fields"

interface ProductInventoryFilterChipsProps {
  searchParams: ProductInventoriesSearchParams
  productStatusOptions: Option<string>[]
  productInventoryStatusOptions: Option<string>[]
  productManagerOptions: Option<string>[]
  productClassOptions: Option<string>[]
  onRemove: (key: keyof ProductInventoriesSearchParams, value?: string | number) => void
}

export const ProductInventoryFilterChips: FC<ProductInventoryFilterChipsProps> = ({
  searchParams,
  productStatusOptions,
  productInventoryStatusOptions,
  productManagerOptions,
  productClassOptions,
  onRemove,
}) => {
  const productStatuses = (searchParams.productStatuses ?? []).map(String)
  const inventoryStatuses = searchParams.inventoryStatuses ?? []
  const productManagerIds = searchParams.productManagerIds ?? []
  const productClassIds = searchParams.productClassIds ?? []

  const hasActiveFilters =
    productStatuses.length > 0 ||
    inventoryStatuses.length > 0 ||
    productManagerIds.length > 0 ||
    productClassIds.length > 0

  if (!hasActiveFilters) return null

  return (
    <Box className='flex flex-wrap items-center gap-2' data-testid='product-inventory.filter-chips'>
      <Typography variant='body1' className='text-gray-700'>
        Applied filters:
      </Typography>

      <InventoryFilterChipGroup
        label='Product Status'
        values={productStatuses}
        options={productStatusOptions}
        onRemove={(value) => onRemove("productStatuses", value)}
        testId='product-inventory.filter-chips.product-status'
      />

      <InventoryFilterChipGroup
        label='Inventory Status'
        values={inventoryStatuses}
        options={productInventoryStatusOptions}
        onRemove={(value) => onRemove("inventoryStatuses", value)}
        testId='product-inventory.filter-chips.inventory-status'
      />

      <InventoryFilterChipGroup
        label='Product Manager'
        values={productManagerIds}
        options={productManagerOptions}
        onRemove={(value) => onRemove("productManagerIds", value)}
        testId='product-inventory.filter-chips.product-manager'
      />

      <InventoryFilterChipGroup
        label='Category/Class'
        values={productClassIds}
        options={productClassOptions}
        onRemove={(value) => onRemove("productClassIds", value)}
        testId='product-inventory.filter-chips.product-class'
      />
    </Box>
  )
}
